// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { BulkDeleteSpaceMemoryItemsData, BulkDeleteSpaceMemoryItemsErrors, BulkDeleteSpaceMemoryItemsResponses, CreateAssistantData, CreateAssistantErrors, CreateAssistantResponses, CreateAssistantTemplateFromAssistantData, CreateAssistantTemplateFromAssistantErrors, CreateAssistantTemplateFromAssistantResponses, CreateDatasetData, CreateDatasetErrors, CreateDatasetResponses, CreateMemoryFromThreadData, CreateMemoryFromThreadErrors, CreateMemoryFromThreadResponses, CreateProjectData, CreateProjectErrors, CreateProjectResponses, CreateSpaceData, CreateSpaceErrors, CreateSpaceMemoryItemData, CreateSpaceMemoryItemErrors, CreateSpaceMemoryItemResponses, CreateSpaceResponses, DeleteAssistantData, DeleteAssistantErrors, DeleteAssistantResponses, DeleteAssistantTemplateData, DeleteAssistantTemplateErrors, DeleteAssistantTemplateResponses, DeleteAssistantThreadData, DeleteAssistantThreadErrors, DeleteAssistantThreadResponses, DeleteDatasetData, DeleteDatasetErrors, DeleteDatasetResponses, DeleteDataSourcesData, DeleteDataSourcesErrors, DeleteDataSourcesResponses, DeleteProjectData, DeleteProjectErrors, DeleteProjectResponses, DeleteSpaceData, DeleteSpaceErrors, DeleteSpaceMemoryItemData, DeleteSpaceMemoryItemErrors, DeleteSpaceMemoryItemResponses, DeleteSpaceResponses, DeleteThreadData, DeleteThreadErrors, DeleteThreadResponses, GenerateFileUploadUrlsData, GenerateFileUploadUrlsErrors, GenerateFileUploadUrlsResponses, GenerateS3PresignedUrlsData, GenerateS3PresignedUrlsErrors, GenerateS3PresignedUrlsResponses, GenerateSpaceFileUploadUrlsData, GenerateSpaceFileUploadUrlsErrors, GenerateSpaceFileUploadUrlsResponses, GenerateThreadMemorySummaryData, GenerateThreadMemorySummaryErrors, GenerateThreadMemorySummaryResponses, GetAssistantChangelogData, GetAssistantChangelogErrors, GetAssistantChangelogResponses, GetAssistantData, GetAssistantErrors, GetAssistantResponses, GetAssistantTemplateData, GetAssistantTemplateErrors, GetAssistantTemplateResponses, GetAssistantThreadByIdData, GetAssistantThreadByIdErrors, GetAssistantThreadByIdResponses, GetDatasetByIdData, GetDatasetByIdErrors, GetDatasetByIdResponses, GetDragDatasetByIdData, GetDragDatasetByIdErrors, GetDragDatasetByIdResponses, GetDragProjectByIdData, GetDragProjectByIdErrors, GetDragProjectByIdResponses, GetProjectByIdData, GetProjectByIdErrors, GetProjectByIdResponses, GetProjectChangelogData, GetProjectChangelogErrors, GetProjectChangelogResponses, GetRagSourcesData, GetRagSourcesErrors, GetRagSourcesResponses, GetReferenceDataData, GetReferenceDataErrors, GetReferenceDataResponses, GetSpaceByIdData, GetSpaceByIdErrors, GetSpaceByIdResponses, GetSpaceMemoryData, GetSpaceMemoryErrors, GetSpaceMemoryItemData, GetSpaceMemoryItemErrors, GetSpaceMemoryItemResponses, GetSpaceMemoryResponses, GetSpaceMemorySyncStatusData, GetSpaceMemorySyncStatusErrors, GetSpaceMemorySyncStatusResponses, GetThreadByIdData, GetThreadByIdErrors, GetThreadByIdResponses, GetThreadMemorySummaryData, GetThreadMemorySummaryErrors, GetThreadMemorySummaryResponses, GetUserProfileData, GetUserProfileErrors, GetUserProfileResponses, LambdaChatChatPostData, LambdaChatChatPostErrors, LambdaChatChatPostResponses, ListAssistantsData, ListAssistantsErrors, ListAssistantsResponses, ListAssistantTemplatesData, ListAssistantTemplatesErrors, ListAssistantTemplatesResponses, ListAssistantThreadsData, ListAssistantThreadsErrors, ListAssistantThreadsResponses, ListDatasetsData, ListDatasetsErrors, ListDatasetsResponses, ListDataSourcesData, ListDataSourcesErrors, ListDataSourcesResponses, ListProjectsData, ListProjectsErrors, ListProjectsResponses, ListProjectThreadsData, ListProjectThreadsErrors, ListProjectThreadsResponses, ListSpaceMemoryItemsData, ListSpaceMemoryItemsErrors, ListSpaceMemoryItemsResponses, ListSpacesData, ListSpacesErrors, ListSpacesResponses, ProcessDragData, ProcessDragErrors, ProcessDragResponses, ProcessFilesData, ProcessFilesErrors, ProcessFilesResponses, SearchUsersData, SearchUsersErrors, SearchUsersResponses, SyncSpaceMemoryData, SyncSpaceMemoryErrors, SyncSpaceMemoryResponses, SynthesizeSpaceMemoryData, SynthesizeSpaceMemoryErrors, SynthesizeSpaceMemoryResponses, UpdateAssistantData, UpdateAssistantErrors, UpdateAssistantResponses, UpdateAssistantTemplateData, UpdateAssistantTemplateErrors, UpdateAssistantTemplateResponses, UpdateAssistantThreadData, UpdateAssistantThreadErrors, UpdateAssistantThreadResponses, UpdateDatasetData, UpdateDatasetErrors, UpdateDatasetResponses, UpdateDataSourcesData, UpdateDataSourcesErrors, UpdateDataSourcesResponses, UpdateProjectData, UpdateProjectErrors, UpdateProjectResponses, UpdateSpaceData, UpdateSpaceErrors, UpdateSpaceMemoryItemData, UpdateSpaceMemoryItemErrors, UpdateSpaceMemoryItemResponses, UpdateSpaceResponses, UpdateThreadData, UpdateThreadErrors, UpdateThreadResponses, UpdateUserProfileData, UpdateUserProfileErrors, UpdateUserProfileResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get Referencedata
 *
 * Get reference data for the authenticated application. Returns configuration and lookup values such as available AI models, chunk sizes, retrieval counts, data classifications, file types, and other dropdown/lookup data used by the application. Requires authentication.
 */
export const getReferenceData = <ThrowOnError extends boolean = false>(options?: Options<GetReferenceDataData, ThrowOnError>) => (options?.client ?? client).get<GetReferenceDataResponses, GetReferenceDataErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/reference-data',
    ...options
});

/**
 * Get User
 *
 * Get the current authenticated user's details. Requires authentication.
 */
export const getUserProfile = <ThrowOnError extends boolean = false>(options?: Options<GetUserProfileData, ThrowOnError>) => (options?.client ?? client).get<GetUserProfileResponses, GetUserProfileErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/user',
    ...options
});

/**
 * Put User
 */
export const updateUserProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateUserProfileData, ThrowOnError>) => (options.client ?? client).put<UpdateUserProfileResponses, UpdateUserProfileErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Search Users
 *
 * Search for users by email, username, name, or all fields using Okta directory
 *
 * Args:
 * search: The search term to look for
 * search_type: Type of search (email, username, name, both, or all)
 * - email: Search by email address only
 * - username: Search by username/login only
 * - name: Search by first or last name
 * - both: Search by email and username (default)
 * - all: Search across email, username, firstName, and lastName
 *
 * Returns:
 * A list of matching users with id, email, login, firstName, and lastName.
 * Returns empty list if no matches found (not an error).
 */
export const searchUsers = <ThrowOnError extends boolean = false>(options: Options<SearchUsersData, ThrowOnError>) => (options.client ?? client).get<SearchUsersResponses, SearchUsersErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/users/search',
    ...options
});

/**
 * Get Datasets
 *
 * List all datasets accessible to the authenticated user. Returns datasets where the user has OWNER, CONTRIBUTOR, or VIEWER role.
 */
export const listDatasets = <ThrowOnError extends boolean = false>(options?: Options<ListDatasetsData, ThrowOnError>) => (options?.client ?? client).get<ListDatasetsResponses, ListDatasetsErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/datasets',
    ...options
});

/**
 * Post Datasets
 *
 * Create a new dataset. Supports both RAG and DRAG type datasets with configurable vector settings, data sources, and access controls. Returns the created dataset with owner role assigned.
 */
export const createDataset = <ThrowOnError extends boolean = false>(options: Options<CreateDatasetData, ThrowOnError>) => (options.client ?? client).post<CreateDatasetResponses, CreateDatasetErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/datasets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Dataset
 *
 * Delete a dataset by ID. The dataset must not be in use by any projects and a datasource must not be linked to any assistants. Requires OWNER role. Returns 204 No Content upon successful deletion.
 */
export const deleteDataset = <ThrowOnError extends boolean = false>(options: Options<DeleteDatasetData, ThrowOnError>) => (options.client ?? client).delete<DeleteDatasetResponses, DeleteDatasetErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/datasets/{dataset}',
    ...options
});

/**
 * Get Dataset
 *
 * Get details of a specific dataset by ID. Returns comprehensive information including vector configuration, data sources, sharing settings, and the user's role for the dataset.
 */
export const getDatasetById = <ThrowOnError extends boolean = false>(options: Options<GetDatasetByIdData, ThrowOnError>) => (options.client ?? client).get<GetDatasetByIdResponses, GetDatasetByIdErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/datasets/{dataset}',
    ...options
});

/**
 * Put Dataset
 *
 * Update an existing dataset's configuration. Can modify metadata, vector settings, and sharing permissions. Requires OWNER or CONTRIBUTOR role.
 */
export const updateDataset = <ThrowOnError extends boolean = false>(options: Options<UpdateDatasetData, ThrowOnError>) => (options.client ?? client).put<UpdateDatasetResponses, UpdateDatasetErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/datasets/{dataset}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Drag Dataset
 *
 * Get details of a specific DRAG dataset by ID without response model validation. Returns raw dataset data including all DRAG-specific fields like drag_S3_configuration, drag_statistics, and other DRAG-related configuration.
 */
export const getDragDatasetById = <ThrowOnError extends boolean = false>(options: Options<GetDragDatasetByIdData, ThrowOnError>) => (options.client ?? client).get<GetDragDatasetByIdResponses, GetDragDatasetByIdErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/datasets/{dataset}/drag',
    ...options
});

/**
 * Delete Datasources
 *
 * Remove all data sources from a dataset. Must not be in use. Requires appropriate permissions. Returns 204 No Content upon successful deletion.
 */
export const deleteDataSources = <ThrowOnError extends boolean = false>(options: Options<DeleteDataSourcesData, ThrowOnError>) => (options.client ?? client).delete<DeleteDataSourcesResponses, DeleteDataSourcesErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/datasets/{dataset}/datasources',
    ...options
});

/**
 * Get Datasources
 *
 * List all data sources associated with a dataset. Returns information about files, their processing status, and ingestion statistics.
 *
 * This endpoint follows the collection response pattern:
 * - Response: {"dataSources": [...]} - Array of datasource objects
 *
 * Each datasource object includes metadata about the file, processing status, ingestion statistics, and S3 location.
 */
export const listDataSources = <ThrowOnError extends boolean = false>(options: Options<ListDataSourcesData, ThrowOnError>) => (options.client ?? client).get<ListDataSourcesResponses, ListDataSourcesErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/datasets/{dataset}/datasources',
    ...options
});

/**
 * Patch Datasources
 *
 * Update data sources for a dataset. Can modify source configurations. Requires appropriate permissions.
 *
 * This endpoint follows the collection update pattern:
 * - Request: {"dataSources": [...]} - Array of datasource objects to update
 * - Response: {"dataSources": [...]} - Array of updated datasource objects
 *
 * Each datasource object in the request should include the 'id' field to identify which datasource to update.
 * Only provided fields will be updated (partial update).
 */
export const updateDataSources = <ThrowOnError extends boolean = false>(options: Options<UpdateDataSourcesData, ThrowOnError>) => (options.client ?? client).patch<UpdateDataSourcesResponses, UpdateDataSourcesErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/datasets/{dataset}/datasources',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Process Files
 *
 * Initiates processing of uploaded files within a dataset. This includes vectorization, chunking, and indexing of documents for search and retrieval. Can optionally force reprocessing of already processed files. Requires CONTRIBUTOR or OWNER role.
 */
export const processFiles = <ThrowOnError extends boolean = false>(options: Options<ProcessFilesData, ThrowOnError>) => (options.client ?? client).post<ProcessFilesResponses, ProcessFilesErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/datasets/{dataset}/process-files',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post S3 Presigned Urls
 *
 * Generates S3 presigned URLs for uploading files to a specified dataset. Returns the presigned URLs that can be used for direct file uploads to S3.
 */
export const generateS3PresignedUrls = <ThrowOnError extends boolean = false>(options: Options<GenerateS3PresignedUrlsData, ThrowOnError>) => (options.client ?? client).post<GenerateS3PresignedUrlsResponses, GenerateS3PresignedUrlsErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/datasets/{dataset}/s3-presigned-urls',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Project File Upload Urls
 *
 * Generates S3 presigned POST URLs for uploading files to a project. Returns the presigned data for direct uploads to S3.
 */
export const generateFileUploadUrls = <ThrowOnError extends boolean = false>(options: Options<GenerateFileUploadUrlsData, ThrowOnError>) => (options.client ?? client).post<GenerateFileUploadUrlsResponses, GenerateFileUploadUrlsErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project}/files',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Projects
 *
 * List all projects accessible to the authenticated user. Returns projects where the user has OWNER, CONTRIBUTOR, or VIEWER role. Each project includes configuration details, associated datasets, and the user's role.
 */
export const listProjects = <ThrowOnError extends boolean = false>(options?: Options<ListProjectsData, ThrowOnError>) => (options?.client ?? client).get<ListProjectsResponses, ListProjectsErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects',
    ...options
});

/**
 * Post Project
 *
 * Create a new AI project. Projects are workspaces that combine datasets with LLM configurations, prompts, and query settings to interact with a dataset. Returns the created project with owner role assigned.
 */
export const createProject = <ThrowOnError extends boolean = false>(options: Options<CreateProjectData, ThrowOnError>) => (options.client ?? client).post<CreateProjectResponses, CreateProjectErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Project
 *
 * Delete a project by ID. This will also remove all associated threads and conversation history. Requires OWNER role. Returns 204 No Content upon successful deletion.
 */
export const deleteProject = <ThrowOnError extends boolean = false>(options: Options<DeleteProjectData, ThrowOnError>) => (options.client ?? client).delete<DeleteProjectResponses, DeleteProjectErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project}',
    ...options
});

/**
 * Get Project
 *
 * Get details of a specific project by ID. Returns comprehensive project information including LLM configuration, dataset associations, prompts, query settings, sharing permissions, and the user's role for the project.
 */
export const getProjectById = <ThrowOnError extends boolean = false>(options: Options<GetProjectByIdData, ThrowOnError>) => (options.client ?? client).get<GetProjectByIdResponses, GetProjectByIdErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project}',
    ...options
});

/**
 * Put Project
 *
 * Update an existing project's configuration. Can modify metadata, LLM settings, prompts, query parameters, dataset associations, and sharing permissions. Requires OWNER or CONTRIBUTOR role.
 */
export const updateProject = <ThrowOnError extends boolean = false>(options: Options<UpdateProjectData, ThrowOnError>) => (options.client ?? client).put<UpdateProjectResponses, UpdateProjectErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Drag Project
 *
 * Get details of a specific DRAG project by ID without response model validation. Returns raw project data including all DRAG-specific fields like prompt_template_id_matches, match_unique_tag, and process_status.
 */
export const getDragProjectById = <ThrowOnError extends boolean = false>(options: Options<GetDragProjectByIdData, ThrowOnError>) => (options.client ?? client).get<GetDragProjectByIdResponses, GetDragProjectByIdErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project}/drag',
    ...options
});

/**
 * Post Process Drag
 *
 * Initiates DRAG (Deterministic Retrieval-Augmented Generation) processing for a project. This prepares the project's dataset for enhanced AI interactions by processing and optimizing the data for retrieval operations. Returns job details for tracking processing status. TO BE DEPRECATED IN FUTURE RELEASES.
 */
export const processDrag = <ThrowOnError extends boolean = false>(options: Options<ProcessDragData, ThrowOnError>) => (options.client ?? client).post<ProcessDragResponses, ProcessDragErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project}/process-drag',
    ...options
});

/**
 * Get Changelog
 *
 * Get the changelog for a specific project. Returns a list of changes and modifications made to the project over time, useful for tracking project evolution and audit purposes.
 */
export const getProjectChangelog = <ThrowOnError extends boolean = false>(options: Options<GetProjectChangelogData, ThrowOnError>) => (options.client ?? client).get<GetProjectChangelogResponses, GetProjectChangelogErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project}/changelog',
    ...options
});

/**
 * Get Threads
 *
 * List all conversation threads within a project. Threads represent individual chat sessions or conversations with the AI assistant. Returns thread metadata and conversation history. Optionally filter by assistant_id or space_id (cannot use both simultaneously).
 */
export const listProjectThreads = <ThrowOnError extends boolean = false>(options: Options<ListProjectThreadsData, ThrowOnError>) => (options.client ?? client).get<ListProjectThreadsResponses, ListProjectThreadsErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project}/threads',
    ...options
});

/**
 * Delete Thread
 *
 * Delete a specific conversation thread by ID. This will permanently remove the thread and all associated conversation history. Requires appropriate permissions. Returns 204 No Content upon successful deletion.
 */
export const deleteThread = <ThrowOnError extends boolean = false>(options: Options<DeleteThreadData, ThrowOnError>) => (options.client ?? client).delete<DeleteThreadResponses, DeleteThreadErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project}/threads/{thread}',
    ...options
});

/**
 * Get Thread
 *
 * Get details of a specific conversation thread by ID. Returns the complete conversation history, messages, and thread metadata for a particular chat session within a project.
 */
export const getThreadById = <ThrowOnError extends boolean = false>(options: Options<GetThreadByIdData, ThrowOnError>) => (options.client ?? client).get<GetThreadByIdResponses, GetThreadByIdErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project}/threads/{thread}',
    ...options
});

/**
 * Patch Thread
 *
 * Update an existing conversation thread. Can modify thread name and spaceId. Requires appropriate permissions.
 */
export const updateThread = <ThrowOnError extends boolean = false>(options: Options<UpdateThreadData, ThrowOnError>) => (options.client ?? client).patch<UpdateThreadResponses, UpdateThreadErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project}/threads/{thread}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Ragsource
 *
 * Get the RAG (Retrieval-Augmented Generation) sources for a specific message in a conversation thread. Returns the document sources and context that were used to generate the AI response for that particular message.
 */
export const getRagSources = <ThrowOnError extends boolean = false>(options: Options<GetRagSourcesData, ThrowOnError>) => (options.client ?? client).get<GetRagSourcesResponses, GetRagSourcesErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project}/threads/{thread}/{message}',
    ...options
});

/**
 * Get Assistants
 *
 * List all assistants for a project. Requires authentication.
 */
export const listAssistants = <ThrowOnError extends boolean = false>(options: Options<ListAssistantsData, ThrowOnError>) => (options.client ?? client).get<ListAssistantsResponses, ListAssistantsErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project_id}/assistants',
    ...options
});

/**
 * Create Assistant
 *
 * Create a new assistant in a project. Requires authentication.
 */
export const createAssistant = <ThrowOnError extends boolean = false>(options: Options<CreateAssistantData, ThrowOnError>) => (options.client ?? client).post<CreateAssistantResponses, CreateAssistantErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project_id}/assistants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Assistant
 *
 * Delete an assistant in a project. Requires authentication.
 */
export const deleteAssistant = <ThrowOnError extends boolean = false>(options: Options<DeleteAssistantData, ThrowOnError>) => (options.client ?? client).delete<DeleteAssistantResponses, DeleteAssistantErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project_id}/assistants/{assistant_id}',
    ...options
});

/**
 * Get Assistant
 *
 * Get a specific assistant in a project. Requires authentication.
 */
export const getAssistant = <ThrowOnError extends boolean = false>(options: Options<GetAssistantData, ThrowOnError>) => (options.client ?? client).get<GetAssistantResponses, GetAssistantErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project_id}/assistants/{assistant_id}',
    ...options
});

/**
 * Update Assistant
 *
 * Update an assistant in a project. Requires authentication.
 */
export const updateAssistant = <ThrowOnError extends boolean = false>(options: Options<UpdateAssistantData, ThrowOnError>) => (options.client ?? client).put<UpdateAssistantResponses, UpdateAssistantErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project_id}/assistants/{assistant_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Assistant Changelog
 *
 * Get the changelog for a specific assistant. Returns a list of changes and modifications made to the assistant over time, useful for tracking assistant evolution and audit purposes.
 */
export const getAssistantChangelog = <ThrowOnError extends boolean = false>(options: Options<GetAssistantChangelogData, ThrowOnError>) => (options.client ?? client).get<GetAssistantChangelogResponses, GetAssistantChangelogErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project_id}/assistants/{assistant_id}/changelog',
    ...options
});

/**
 * List Assistant Templates
 *
 * List all assistant templates (with usage stats). Publicly readable.
 */
export const listAssistantTemplates = <ThrowOnError extends boolean = false>(options?: Options<ListAssistantTemplatesData, ThrowOnError>) => (options?.client ?? client).get<ListAssistantTemplatesResponses, ListAssistantTemplatesErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/assistant-templates',
    ...options
});

/**
 * Create Assistant Template From Assistant
 *
 * Create a new assistant template from an existing assistant's configuration.
 */
export const createAssistantTemplateFromAssistant = <ThrowOnError extends boolean = false>(options: Options<CreateAssistantTemplateFromAssistantData, ThrowOnError>) => (options.client ?? client).post<CreateAssistantTemplateFromAssistantResponses, CreateAssistantTemplateFromAssistantErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/assistant-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Assistant Template
 *
 * Delete assistant template. Only owner can delete.
 */
export const deleteAssistantTemplate = <ThrowOnError extends boolean = false>(options: Options<DeleteAssistantTemplateData, ThrowOnError>) => (options.client ?? client).delete<DeleteAssistantTemplateResponses, DeleteAssistantTemplateErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/assistant-templates/{template_id}',
    ...options
});

/**
 * Get Assistant Template
 *
 * Get specific assistant template (with usage records). Publicly readable.
 */
export const getAssistantTemplate = <ThrowOnError extends boolean = false>(options: Options<GetAssistantTemplateData, ThrowOnError>) => (options.client ?? client).get<GetAssistantTemplateResponses, GetAssistantTemplateErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/assistant-templates/{template_id}',
    ...options
});

/**
 * Update Assistant Template
 *
 * Update assistant template. Only owner can update.
 */
export const updateAssistantTemplate = <ThrowOnError extends boolean = false>(options: Options<UpdateAssistantTemplateData, ThrowOnError>) => (options.client ?? client).put<UpdateAssistantTemplateResponses, UpdateAssistantTemplateErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/assistant-templates/{template_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Assistant Threads
 *
 * List all conversation threads for an assistant. Requires authentication.
 */
export const listAssistantThreads = <ThrowOnError extends boolean = false>(options: Options<ListAssistantThreadsData, ThrowOnError>) => (options.client ?? client).get<ListAssistantThreadsResponses, ListAssistantThreadsErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project_id}/assistants/{assistant_id}/threads',
    ...options
});

/**
 * Delete Assistant Thread
 *
 * Delete a specific assistant thread by ID. This will permanently remove the thread and all associated conversation history. Requires appropriate permissions. Returns 204 No Content upon successful deletion.
 */
export const deleteAssistantThread = <ThrowOnError extends boolean = false>(options: Options<DeleteAssistantThreadData, ThrowOnError>) => (options.client ?? client).delete<DeleteAssistantThreadResponses, DeleteAssistantThreadErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project_id}/assistants/{assistant_id}/threads/{thread_id}',
    ...options
});

/**
 * Get Assistant Thread
 *
 * Get details of a specific assistant thread by ID. Returns the complete conversation history, messages, and thread metadata for a particular chat session within an assistant.
 */
export const getAssistantThreadById = <ThrowOnError extends boolean = false>(options: Options<GetAssistantThreadByIdData, ThrowOnError>) => (options.client ?? client).get<GetAssistantThreadByIdResponses, GetAssistantThreadByIdErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project_id}/assistants/{assistant_id}/threads/{thread_id}',
    ...options
});

/**
 * Update Assistant Thread
 *
 * Update an existing assistant thread name. Only the thread name can be modified. Requires appropriate permissions.
 */
export const updateAssistantThread = <ThrowOnError extends boolean = false>(options: Options<UpdateAssistantThreadData, ThrowOnError>) => (options.client ?? client).patch<UpdateAssistantThreadResponses, UpdateAssistantThreadErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/projects/{project_id}/assistants/{assistant_id}/threads/{thread_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Spaces
 *
 * List all spaces owned by the authenticated user.
 */
export const listSpaces = <ThrowOnError extends boolean = false>(options?: Options<ListSpacesData, ThrowOnError>) => (options?.client ?? client).get<ListSpacesResponses, ListSpacesErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/spaces',
    ...options
});

/**
 * Post Space
 *
 * Create a new space. The authenticated principal user is automatically set as the space owner. Returns the created space with generated ID.
 */
export const createSpace = <ThrowOnError extends boolean = false>(options: Options<CreateSpaceData, ThrowOnError>) => (options.client ?? client).post<CreateSpaceResponses, CreateSpaceErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/spaces',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Space
 *
 * Delete a space by ID. Only allowed by space owner based on Principal UserId. Returns 204 No Content upon successful deletion.
 */
export const deleteSpace = <ThrowOnError extends boolean = false>(options: Options<DeleteSpaceData, ThrowOnError>) => (options.client ?? client).delete<DeleteSpaceResponses, DeleteSpaceErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/spaces/{space_id}',
    ...options
});

/**
 * Get Space
 *
 * Get details of a specific space by ID. Only accessible by the space owner based on Principal UserId.
 */
export const getSpaceById = <ThrowOnError extends boolean = false>(options: Options<GetSpaceByIdData, ThrowOnError>) => (options.client ?? client).get<GetSpaceByIdResponses, GetSpaceByIdErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/spaces/{space_id}',
    ...options
});

/**
 * Put Space
 *
 * Update an existing space's information. Can modify name, instructions, and attached files. Only allowed by space owner based on Principal UserId.
 */
export const updateSpace = <ThrowOnError extends boolean = false>(options: Options<UpdateSpaceData, ThrowOnError>) => (options.client ?? client).put<UpdateSpaceResponses, UpdateSpaceErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/spaces/{space_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Post Space File Upload Urls
 *
 * Generate S3 presigned POST URLs for uploading files to a space.
 *
 * Space files are stored persistently:
 * - Original: `spaces/{space_id}/{timestamp}_{filename}`
 * - Converted: `spaces/{space_id}/{timestamp}_{basename}.extracted.md`
 *
 * Unlike regular project files, space files are NOT deleted after text extraction.
 * Both the original and the extracted content are retained for persistent reference.
 *
 * The converted file path can be derived from the original by replacing the extension
 * with `.extracted.md`. The response includes `spaceId` and `isSpaceFile` flags.
 */
export const generateSpaceFileUploadUrls = <ThrowOnError extends boolean = false>(options: Options<GenerateSpaceFileUploadUrlsData, ThrowOnError>) => (options.client ?? client).post<GenerateSpaceFileUploadUrlsResponses, GenerateSpaceFileUploadUrlsErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/spaces/{space_id}/s3-presigned-urls',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Space Memory
 *
 * Get synthesized memory for a space. Returns the unified memory summary combining implicit thread summaries and explicit user memories.
 */
export const getSpaceMemory = <ThrowOnError extends boolean = false>(options: Options<GetSpaceMemoryData, ThrowOnError>) => (options.client ?? client).get<GetSpaceMemoryResponses, GetSpaceMemoryErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/spaces/{space_id}/memory',
    ...options
});

/**
 * Get Space Memory Sync Status
 *
 * Check which threads have changes that need to be synced to space memory. Returns list of threads needing summary updates.
 */
export const getSpaceMemorySyncStatus = <ThrowOnError extends boolean = false>(options: Options<GetSpaceMemorySyncStatusData, ThrowOnError>) => (options.client ?? client).get<GetSpaceMemorySyncStatusResponses, GetSpaceMemorySyncStatusErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/spaces/{space_id}/memory/sync-status',
    ...options
});

/**
 * Sync Space Memory
 *
 * Smart sync: update only changed threads and resynthesize space memory. Only regenerates summaries for threads with new messages. Requires project_id to fetch thread data.
 */
export const syncSpaceMemory = <ThrowOnError extends boolean = false>(options: Options<SyncSpaceMemoryData, ThrowOnError>) => (options.client ?? client).post<SyncSpaceMemoryResponses, SyncSpaceMemoryErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/spaces/{space_id}/memory/sync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Synthesize Space Memory Endpoint
 *
 * Synthesize space memory from current memory items. Uses existing thread summaries without regeneration.
 */
export const synthesizeSpaceMemory = <ThrowOnError extends boolean = false>(options: Options<SynthesizeSpaceMemoryData, ThrowOnError>) => (options.client ?? client).post<SynthesizeSpaceMemoryResponses, SynthesizeSpaceMemoryErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/spaces/{space_id}/memory/synthesize',
    ...options
});

/**
 * Bulk Delete Memory Items
 *
 * Bulk delete memory items. Can delete all items, only implicit summaries, or only explicit memories.
 */
export const bulkDeleteSpaceMemoryItems = <ThrowOnError extends boolean = false>(options: Options<BulkDeleteSpaceMemoryItemsData, ThrowOnError>) => (options.client ?? client).delete<BulkDeleteSpaceMemoryItemsResponses, BulkDeleteSpaceMemoryItemsErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/spaces/{space_id}/memory/items',
    ...options
});

/**
 * Get Memory Items
 *
 * List all memory items for a space. Can filter by source type (implicit_summary or explicit).
 */
export const listSpaceMemoryItems = <ThrowOnError extends boolean = false>(options: Options<ListSpaceMemoryItemsData, ThrowOnError>) => (options.client ?? client).get<ListSpaceMemoryItemsResponses, ListSpaceMemoryItemsErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/spaces/{space_id}/memory/items',
    ...options
});

/**
 * Create Memory Item
 *
 * Create a new memory item. Can be implicit (references thread summary) or explicit (user-created content).
 */
export const createSpaceMemoryItem = <ThrowOnError extends boolean = false>(options: Options<CreateSpaceMemoryItemData, ThrowOnError>) => (options.client ?? client).post<CreateSpaceMemoryItemResponses, CreateSpaceMemoryItemErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/spaces/{space_id}/memory/items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Memory Item
 *
 * Delete a memory item (soft delete - marks as excluded). Returns 204 No Content upon successful deletion.
 */
export const deleteSpaceMemoryItem = <ThrowOnError extends boolean = false>(options: Options<DeleteSpaceMemoryItemData, ThrowOnError>) => (options.client ?? client).delete<DeleteSpaceMemoryItemResponses, DeleteSpaceMemoryItemErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/spaces/{space_id}/memory/items/{item_id}',
    ...options
});

/**
 * Get Memory Item
 *
 * Get a specific memory item by ID.
 */
export const getSpaceMemoryItem = <ThrowOnError extends boolean = false>(options: Options<GetSpaceMemoryItemData, ThrowOnError>) => (options.client ?? client).get<GetSpaceMemoryItemResponses, GetSpaceMemoryItemErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/spaces/{space_id}/memory/items/{item_id}',
    ...options
});

/**
 * Update Memory Item
 *
 * Update a memory item. Only explicit memories can be updated (content, tags, importance).
 */
export const updateSpaceMemoryItem = <ThrowOnError extends boolean = false>(options: Options<UpdateSpaceMemoryItemData, ThrowOnError>) => (options.client ?? client).patch<UpdateSpaceMemoryItemResponses, UpdateSpaceMemoryItemErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/spaces/{space_id}/memory/items/{item_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create Memory From Thread
 *
 * Create an explicit memory from a thread message. Shortcut for creating explicit memories tied to specific threads.
 */
export const createMemoryFromThread = <ThrowOnError extends boolean = false>(options: Options<CreateMemoryFromThreadData, ThrowOnError>) => (options.client ?? client).post<CreateMemoryFromThreadResponses, CreateMemoryFromThreadErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/spaces/{space_id}/threads/{thread_id}/remember',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Thread Summary
 *
 * Get memory summary for a specific thread. Requires project_id to locate the thread.
 */
export const getThreadMemorySummary = <ThrowOnError extends boolean = false>(options: Options<GetThreadMemorySummaryData, ThrowOnError>) => (options.client ?? client).get<GetThreadMemorySummaryResponses, GetThreadMemorySummaryErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/spaces/{space_id}/threads/{thread_id}/summary',
    ...options
});

/**
 * Generate Thread Summary
 *
 * Generate memory summary for a thread using AI. Updates the thread's memory_summary field. Requires project_id to locate the thread.
 */
export const generateThreadMemorySummary = <ThrowOnError extends boolean = false>(options: Options<GenerateThreadMemorySummaryData, ThrowOnError>) => (options.client ?? client).post<GenerateThreadMemorySummaryResponses, GenerateThreadMemorySummaryErrors, ThrowOnError>({
    security: [
        { name: 'spark-ai-app-id', type: 'apiKey' },
        { name: 'spark-ai-app-key', type: 'apiKey' },
        { name: 'spark-ai-app-user', type: 'apiKey' },
        { scheme: 'bearer', type: 'http' }
    ],
    url: '/spaces/{space_id}/threads/{thread_id}/summary',
    ...options
});

/**
 * Lambda Chat
 */
export const lambdaChatChatPost = <ThrowOnError extends boolean = false>(options: Options<LambdaChatChatPostData, ThrowOnError>) => (options.client ?? client).post<LambdaChatChatPostResponses, LambdaChatChatPostErrors, ThrowOnError>({
    url: '/chat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
